<template>
  <div class="permission-cookie" v-if="!isPermission && !validateIsH5()">
    <p>
      {{ $t('message.cookiesTis') }}
      <span @click="statementVisible=true">{{ $t('message.learnMore') }}</span>
      <el-button type="primary" @click="permissionCookie">{{$t('btn.ok')}}</el-button>
    </p>
    <!-- 隐私条款弹窗 -->
    <agreement :visible="statementVisible" @visible-change="visibleChange" :lang="$i18n.locale" type="privacy"></agreement>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Agreement from '@/components/base/agreement/Index'

export default {
  name: 'permissionCookie',
  components: {
    Agreement
  },
  data () {
    return {
      statementVisible: false,
      isPermission: localStorage.getItem('is-permission-cookie') || false
    }
  },
  computed: {
    ...mapGetters('login', ['statement'])
  },
  async mounted () {
    this.getStatementApi()
  },
  methods: {
    ...mapActions('login', [
      'getStatementApi'
    ]),
    permissionCookie () {
      localStorage.setItem('is-permission-cookie', true)
      this.isPermission = true
    },
    visibleChange (v) {
      this.statementVisible = v
    },
    validateIsH5 () {
      const isH5 = /windows phone|iphone|android/ig.test(window.navigator.userAgent)
      return isH5
    }
  }
}
</script>

<style lang="stylus" scoped>
.permission-cookie{
  height 60px
  line-height 60px
  width 100%
  position fixed
  top 0
  z-index 99
  text-align center
  background rgba(0,0,0,0.8);
  p {
    font-size 16px
    color #FFF
    span {
      color #1EB5B3
      margin-right 80px
      font-size 16px
      cursor pointer
    }
    button {
      width 112px
      padding 10px 0
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/permissionCookie/Index.vue